export const SET_SELECTED_PROJECT = 'PROJECTS/SET_SELECTED_PROJECT';
export const SET_PROJECTS = 'PROJECTS/SET_PROJECTS';
export const SET_EDIT_PROJECT_MODAL_SHOW = 'PROJECTS/SET_EDIT_PROJECT_MODAL_SHOW';
export const SET_PENDING = 'PROJECTS/SET_PENDING';
export const TOGGLE_FAVORITE_PROJECT = 'PROJECTS/TOGGLE_FAVORITE_PROJECT';

export const SET_PRODUCTS_PENDING = 'PROJECTS/PRODUCTS/SET_PENDING';
export const SET_PRODUCTS = 'PROJECTS/PRODUCTS/SET_DATA';
